module.exports = __webpack_public_path__ + "img/adjustSYJ.bf43896a.png";